module.exports = __webpack_public_path__ + "static/media/fingernail_right_failed.763c0a75.svg";